module.exports = __webpack_public_path__ + "static/assets/aaa2144183bd6151e4741e7ef808c683.svg";